module.exports = __webpack_public_path__ + "img/ic_app-w.e97a8da6.png";